import useSWR from 'swr'
import fetcher from './fetcher'

export default function useStockPrices(id) {
  const { data, error, isLoading } = useSWR(`/api/v1/prices?id=${id}`, fetcher)

  return {
    prices: data,
    isLoading,
    error
  }
}